import { mapGetters } from "vuex";
 
import admin from "./pages/admin.js";
import client from "./pages/client.js";


export const dbSettingsMixin = {
    data: function () {
        return {
            dasboard: [
                {
                    subject: "adminDashboard",
                    endPoint: "adminDashboard",
                    filter: {
                        userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
                    },
                    data:admin
                },  
                {
                    subject: "clientDB",
                    endPoint: "adminDashboard",
                    filter: {
                        clientId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
                    },
                    data:client
                },  
            ],
        }
    },
    methods: {

        getDashboard(subject) {
            var search = this.dasboard.filter(f =>
                f.subject == subject
            );

            if (search[0].filter.hasOwnProperty("userId")) {
                search[0].filter.userId = this.getUserInfo.id;
            }

            if (search[0].filter.hasOwnProperty("clientId")) {
                search[0].filter.clientId = this.getUserInfo.userLink;
            }

            search[0].data.forEach(el => {
                if (el.hasOwnProperty("clientId")) {
                    el.clientId = this.getUserInfo.userLink;
                }
            });
            
            //loop through the data and update the filter id 
            return search[0];
        }


    },
    computed: {
        ...mapGetters({
            getUserInfo: "auth/getUserInfo",
        }),

    },
    created() {
    }
};